import axios from 'axios';
import { BASE_URL } from '../../config';
import { getAccessToken } from '../LoginForm/Auth/auth';

export const filter = async (typeName, column, value) => {
    const token = getAccessToken();

    try {
        const response = await axios.get(
            `${BASE_URL}/geoserver/elektro/ows`,
            {
                params: {
                    service: 'WFS',
                    version: '1.0.0',
                    request: 'GetFeature',
                    typeName: typeName,
                    outputFormat: 'application/json',
                    cql_filter: `${column}='${value}'`
                },
                headers: {
                    Authorization: `Bearer ${token}` // ✅ dodali autorizaciju
                }
            }
        );

        return response.data.features;
    } catch (error) {
        console.error('Greška pri dohvaćanju podataka:', error.response ? error.response.data : error.message);
        return [];
    }
};

export const filterForGeometry = async (typeName, conditions) => {
    const token = getAccessToken();

    try {
        const cqlFilter = conditions.map(({ column, value }) => `${column}='${value}'`).join(' AND ');

        const response = await axios.get(
            `${BASE_URL}/geoserver/elektro/ows`,
            {
                params: {
                    service: 'WFS',
                    version: '1.0.0',
                    request: 'GetFeature',
                    typeName: typeName,
                    outputFormat: 'application/json',
                    cql_filter: cqlFilter,
                },
                headers: {
                    Authorization: `Bearer ${token}` // ✅ dodali autorizaciju
                }
            }
        );

        return response.data.features;
    } catch (error) {
        console.error('Greška pri dohvaćanju podataka:', error.response ? error.response.data : error.message);
        return [];
    }
};
